import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-error-card',
  templateUrl: './error-card.component.html',
})
export class ErrorCardComponent {

  @Input() error: any;
  @Input('message') inputMessage: string;
  @Input() cardVariant: 'default' | 'nested' = 'default';

}
